type Listener = () => void
const listeners = new Set<Listener>()

export function onAuthRefresh(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function emitAuthRefresh() {
  listeners.forEach(fn => fn())
}

export function __resetAuthRefreshListenersForTests() {
  listeners.clear()
}

export function __getAuthRefreshListenerCountForTests() {
  return listeners.size
}
